import { RhyBusInputText } from '@rhybus/form-controls'
import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusKnowledgeGraphInnerview } from '@rhybus/knowledgegraph'
import { ChangeEvent, useEffect, useState } from 'react'
import { getKnowledgeGraphData} from '../../services/knowledgegraph'
import { getTags, knowledgeGraphSearchFields,knowledgeGraphInnerViewFields } from '../../config/configuration'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'
export default function KnowledgeGraph() {
  const [searchValue, setSearchValue] = useState('')
  const [knowledgeGraphItems, setKnowledgeGraphItems] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getKnowledgeGraphData().then(setKnowledgeGraphItems).finally(() => setIsLoading(false))
  }, [])
  const [filteredItems, setFilteredItems] = useState(knowledgeGraphItems)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
  }
  return (<>
  <main id="main-content">
    {isLoading && <PageOverlay />}
    <RhyBusPageHeader
      pageTitle={'Knowledge Base'}
      badgeCount={filteredItems.length}
      pageHeaderIcon="icon-rb-book-open"
      headerRightContent={
        <div className="d-flex align-items-center justify-content-end">
        <label htmlFor="announcements-search" className="sr-only">Search announcements</label>
          <RhyBusInputText
            type='search'
            iconRight={true}
            wrapperClassName='min-w-250'
            customIcon="icon-rb-search"
            placeholder="Search Knowledge Base"
            value={searchValue}
            onChange={handleChange}
          />
        </div>
      }
    />
    <div className='rb-innerview-pages'>
      <RhyBusKnowledgeGraphInnerview
        items={knowledgeGraphItems}
        innerViewFields={knowledgeGraphInnerViewFields}
        searchPlaceholder="Search Knowledge Base..."
        searchFields={knowledgeGraphSearchFields}
        title='Knowledge Base'
        getTags={getTags}
        cardSize="lg"
        onFilteredItemsChange={(items: any) => setFilteredItems(items)}
        searchText={searchValue}
      />
    </div>
   </main>
  </>
  )
}